export enum YellowCardAttribute {
  Handball = 3020,
  RefereeAbuseArgument = 3021,
  ViolentConduct = 3022,
  TimeWasting = 3023,
  ExcessiveCelebration = 3024,
  Diving = 3025,
  TacticalFoul = 3026,
  UnsportingBehaviour = 3027,
  DangerousPlay = 3028,
  SeriousFoul = 3029,
  OffField = 701,
}
